import RAPID_IMG from "../../../assets/imgs/RAPID.svg";
import ZIP_IMG from "../../../assets/imgs/ZIP.svg";
import ACH_IMG from "../../../assets/imgs/Standard_ACH.svg";
import X_ACH_IMG from "../../../assets/imgs/X_ACH.svg";
import CARD_IMG from "../../../assets/imgs/CARD.svg";
import GOOGLE_PAY_IMG from "../../../assets/imgs/GOOGLE_PAY.svg";
import TRANSFER_IMG from "../../../assets/imgs/TRANSFER.svg";
import NETBANKING_IMG from "../../../assets/imgs/NETBANKING.svg";
import CHALLAN_IMG from "../../../assets/imgs/CHALLAN.svg";
import BANK_IMG from "../../../assets/imgs/BANK.svg";
import APPLE_PAY_IMG from "../../../assets/imgs/APPLE_PAY.svg";
import INSTANT_PAYMENT_IMG from "../../../assets/imgs/INSTANT_PAYMENT.svg";
import SWIREPAY_IMG from '../../../assets/imgs/SP_Outline_logo.svg';
import UPI_IMG from '../../../assets/imgs/upi-icon.png';
import PAYPAL_IMG from '../../../assets/imgs/Paypal.svg';
import ZELLE_IMG from '../../../assets/imgs/Zelle.svg';

export const paymentMethodsHelper = {
    X_ACH: { icon: X_ACH_IMG, label: 'X ACH', subText: 'Settlement in 3 business days', key: 'X_ACH' },
    RAPID_ACH: { icon: RAPID_IMG, label: 'RAPID ACH', subText: 'Settlement in 1 business days', key: 'RAPID_ACH' },
    ZIP_ACH: { icon: ZIP_IMG, label: 'ZIP ACH', subText: 'Settlement in 2 business days', key: 'ZIP_ACH' },
    ACH_LEGACY: { icon: ACH_IMG, label: 'Standard ACH', subText: 'Settlement in 5 business days', key: 'ACH_LEGACY' },
    CARD: { icon: CARD_IMG, label: 'Credit / Debit Card', key: 'CARD' },
    GOOGLE_PAY_US: { icon: GOOGLE_PAY_IMG, label: 'GOOGLE PAY', key: 'GOOGLE_PAY_US' },
    SWIREPAY_US: { icon: SWIREPAY_IMG, label: 'SWIREPAY WALLET', key: 'SWIREPAY_US' },
    WALLET: { icon: GOOGLE_PAY_IMG, label: 'GOOGLE PAY', key: 'WALLET' },
    ACH: { icon: BANK_IMG, label: 'BANK', key: 'ACH' },
    NET_BANKING: { icon: NETBANKING_IMG, label: 'NET BANKING', key: 'NET_BANKING' },
    INSTANT_PAYMENT: { icon: INSTANT_PAYMENT_IMG, label: 'INSTANT PAYMENT', key: 'INSTANT_PAYMENT' },
    TRANSFER: { icon: TRANSFER_IMG, label: 'TRANSFER', key: 'TRANSFER' },
    CHALLAN: { icon: CHALLAN_IMG, label: 'CHALLAN', key: 'CHALLAN' },
    APPLE_PAY_US: { icon: APPLE_PAY_IMG, label: 'APPLE PAY', key: 'APPLE_PAY_US' },
    UPI: { icon: UPI_IMG, label: 'UPI', key: 'UPI' },
    PAYPAL_METHOD: { icon: PAYPAL_IMG, label: 'PAY WITH PAYPAL', key: 'PAYPAL_METHOD' },
    ZELLE: { icon: ZELLE_IMG, label: 'ZELLE', key: 'ZELLE' },
};

export const bankPaymentMethods = ['ACH_LEGACY', 'X_ACH', 'ZIP_ACH', 'RAPID_ACH'];

export const omitOtherPayments = ['ACH_LEGACY', 'X_ACH', 'ZIP_ACH', 'RAPID_ACH', 'CARD', 'PAYPAL_WALLET', 'VENMO'];